import { STORAGE_USER_ID } from "../constants/localstorage";
import { goToMessenger } from "../libs/services";
import { getStorage } from "../libs/storage";
import { ChannelKickMemberResponse } from "../proto/ChannelKickMember_pb";
import { ChannelLeftResponse } from "../proto/ChannelLeft_pb";
import { GroupKickMemberResponse } from "../proto/GroupKickMember_pb";
import { GroupLeftResponse } from "../proto/GroupLeft_pb";
import store from "../store";
import { removeRoomMessages } from "../store/messages/actions";
import { removeRoom, removeRoomMember } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomLeftResponse extends BaseHandler<ChannelKickMemberResponse | ChannelLeftResponse | GroupKickMemberResponse | GroupLeftResponse> {
  handle() {
    const roomLeftResponse = this.response.toObject();
    if (roomLeftResponse.memberId === getStorage(STORAGE_USER_ID)) {
      if (roomLeftResponse.roomId === store.getState().rooms.currentRoom) {
        goToMessenger();
      }
      store.dispatch(removeRoom(roomLeftResponse.roomId));
      store.dispatch(
        removeRoomMessages({
          roomId: roomLeftResponse.roomId,
        })
      );
    } else {
      store.dispatch(
        removeRoomMember({
          roomId: roomLeftResponse.roomId,
          memberId: roomLeftResponse.memberId,
        })
      );
    }
  }
}
